import React, { Fragment, useMemo } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import { Table } from "../../../../components/table/Table";
import { getOnlineDevicesForTable } from "../../../../store/devices/devices.selectors";
import { useGetLastSeen } from "../../../../components/devices/useGetLastSeen";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";
import { useIntlTranslate } from "../../../../hooks";
import { DiscoveredDeviceTableHeader } from "./components";
import {
  COLUMNS,
  COLUMNS_MOBILE,
  SUB_HEADER,
  SEARCH_KEYS,
  INITIAL_SORT,
} from "./DiscoveredDevicesTable.consts";

export const DiscoveredDevicesTable = () => {
  const getLastSeen = useGetLastSeen();
  const devices = useSelector(getOnlineDevicesForTable, _.isEqual);
  const translate = useIntlTranslate();
  const caption = translate("refresh_to_see_devices");

  const updatedDevices = useMemo(
    () =>
      _.map(devices, (device) => ({
        ...device,
        unix: device.lastSeen,
        lastSeen: getLastSeen(device.lastSeen),
      })),
    [devices, getLastSeen]
  );

  return (
    <Fragment>
      <Mobile>
        <Table
          header={<DiscoveredDeviceTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          visibleHeader={false}
          data={updatedDevices}
          columns={COLUMNS_MOBILE}
          hiddenColumns={["manufacturer", "lastSeen"]}
          defaultSorted={INITIAL_SORT}
          subHeader={SUB_HEADER}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Mobile>
      <NotMobile>
        <Table
          header={<DiscoveredDeviceTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          columns={COLUMNS}
          data={updatedDevices}
          defaultSorted={INITIAL_SORT}
          subHeader={SUB_HEADER}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </NotMobile>
    </Fragment>
  );
};
